export const PROPERTY_INFO_SECTION = 'PROPERTY_INFO_SECTION';
